import React from 'react';
import { EMOJIS } from '../utils/utils';

const MessageReactions = ({ message, currentUserId, onToggleReaction }) => {
    if (!message.reactions || Object.keys(message.reactions).length === 0) return null;

    const reactionsObj = message.reactions || {};
    const reactionValues = Object.values(reactionsObj);
    const reactionCounts = reactionValues.reduce((acc, emojiId) => {
        acc[emojiId] = (acc[emojiId] || 0) + 1;
        return acc;
    }, {});

    const userReaction = message.reactions ? message.reactions[currentUserId] : null;

    return (
        <div className={`absolute -bottom-3.5 ${message.senderId === currentUserId ? 'right-2' : 'left-2'} z-50 flex items-center gap-1 bg-white dark:bg-[#2A2A2A] rounded-full px-1.5 py-0.5 shadow-sm border border-gray-200 dark:border-[#1A1A1A]`}>
            {Object.entries(reactionCounts).map(([emojiId, count]) => {
                const emojiData = EMOJIS.find((e) => e.id === emojiId);
                if (!emojiData) return null;
                return (
                    <div
                        key={emojiId}
                        onClick={(e) => { e.stopPropagation(); onToggleReaction(message.id, emojiId, userReaction); }}
                        className="flex items-center gap-0.5 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full px-0.5 transition-colors"
                    >
                        <span className="text-[13px] leading-none">{emojiData.char}</span>
                        {count > 1 && (
                            <span className="text-[10px] text-gray-500 dark:text-gray-400 font-medium leading-none">
                                {count}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};


export default MessageReactions;